(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-worldwide"]) return;
  try {
    
  const articles = document.querySelectorAll('.blog-worldwide__article');
  const checkboxes = document.querySelectorAll('#worldwide-filters-sidebar input[data-filter]');

  function getActiveFilters(group) {
    const checked = document.querySelectorAll(`#worldwide-filters-sidebar input[data-filter="${group}"]:checked`);
    if (checked.length === 0) return null;
    return Array.from(checked, (cb) => cb.value);
  }

  function applyFilters() {
    const locations = getActiveFilters('location');
    const years = getActiveFilters('year');
    let visibleIndex = 0;

    articles.forEach((article) => {
      const matchLocation = !locations || locations.includes(article.dataset.location);
      const matchYear = !years || years.includes(article.dataset.year);
      const visible = matchLocation && matchYear;

      article.hidden = !visible;
      article.classList.toggle('is-single', visible && visibleIndex % 2 === 0);

      if (visible) visibleIndex++;
    });
  }

  checkboxes.forEach((cb) => cb.addEventListener('change', () => {
    document.querySelectorAll(`#worldwide-filters-sidebar input[data-filter="${cb.dataset.filter}"]`).forEach((other) => {
      if (other !== cb) {
        other.checked = other.value === cb.value ? cb.checked : false;
      }
    });
    applyFilters();
  }));
  applyFilters();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('header');
  let cloneHeader = null;

  function updateDropdownHeights() {
    header.querySelectorAll('.dropdown__inner').forEach((inner, i) => {
      const value = `${inner.scrollHeight}px`;
      header.style.setProperty(`--height-dropdown-${i + 1}`, value);
      if (cloneHeader) cloneHeader.style.setProperty(`--height-dropdown-${i + 1}`, value);
    });
  }

  updateDropdownHeights();
  window.addEventListener('resize', updateDropdownHeights);

  const toggle = header.querySelector('.search-toggle');

  const searchOverlay = header.querySelector('.search-overlay');

  function syncSearchToClone() {
    if (!cloneHeader) return;
    const open = header.hasAttribute('data-search-open');
    cloneHeader.toggleAttribute('data-search-open', open);
    cloneHeader.querySelector('.search-overlay')?.toggleAttribute('inert', !open);
  }

  toggle.addEventListener('click', () => {
    header.toggleAttribute('data-search-open');
    searchOverlay.toggleAttribute('inert');
    syncSearchToClone();

    if (header.hasAttribute('data-search-open')) {
      header.querySelector('.search-overlay input').focus();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && header.hasAttribute('data-search-open')) {
      header.removeAttribute('data-search-open');
      searchOverlay.setAttribute('inert', '');
      syncSearchToClone();
    }
  });

  // Predictive (live) search via Shopify Section Rendering API
  const PREDICTIVE_DEBOUNCE_MS = 300;
  const PREDICTIVE_MIN_CHARS = 2;
  const PREDICTIVE_SECTION_ID = 'predictive-search';
  const PREDICTIVE_RESOURCE_PARAMS = 'resources[type]=product,query&resources[limit]=6';

  document.querySelectorAll('[data-predictive-search-form]').forEach((form) => {
    const input = form.querySelector('[data-predictive-search-input]');
    const results = form.parentElement.querySelector('[data-predictive-search]') || form.querySelector('[data-predictive-search]');
    if (!input || !results) return;

    let debounceTimer;
    let abortController;

    const hideResults = () => {
      results.hidden = true;
      results.innerHTML = '';
    };

    const baseUrl = form.dataset.predictiveSearchUrl;
    const loadingText = form.dataset.loadingText;

    const showLoading = () => {
      results.hidden = false;
      results.innerHTML = `<p class="predictive-search-results__empty ff-secondary">${loadingText}</p>`;
    };

    const fetchResults = async (term) => {
      if (abortController) abortController.abort();
      abortController = new AbortController();

      const url = `${baseUrl}?q=${encodeURIComponent(term)}&section_id=${PREDICTIVE_SECTION_ID}&${PREDICTIVE_RESOURCE_PARAMS}`;

      try {
        const res = await fetch(url, { signal: abortController.signal });
        if (!res.ok) throw new Error(res.statusText);
        const html = await res.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const fresh = parsed.querySelector('[data-predictive-search-results]');
        if (fresh) {
          results.hidden = false;
          results.innerHTML = fresh.outerHTML;
        }
      } catch (err) {
        if (err.name !== 'AbortError') {
          hideResults();
        }
      }
    };

    input.addEventListener('input', () => {
      const term = input.value.trim();
      clearTimeout(debounceTimer);

      if (term.length < PREDICTIVE_MIN_CHARS) {
        if (abortController) abortController.abort();
        hideResults();
        return;
      }

      showLoading();
      debounceTimer = setTimeout(() => fetchResults(term), PREDICTIVE_DEBOUNCE_MS);
    });

    form.addEventListener('reset', hideResults);

    document.addEventListener('focusin', (e) => {
      if (results.hidden) return;
      if (form.contains(e.target) || results.contains(e.target)) return;
      hideResults();
    });

    document.addEventListener('pointerdown', (e) => {
      if (results.hidden) return;
      if (form.contains(e.target) || results.contains(e.target)) return;
      hideResults();
    });

    input.addEventListener('focus', () => {
      const term = input.value.trim();
      if (term.length >= PREDICTIVE_MIN_CHARS && results.innerHTML.trim()) {
        results.hidden = false;
      }
    });
  });

  // Decorative blurred clone, kept as a sibling of the real header and synced to it.
  // Built last so none of the listeners above bind to its (inert, invisible) copies.
  cloneHeader = header.cloneNode(true);
  cloneHeader.classList.add('header-clone');
  cloneHeader.setAttribute('aria-hidden', 'true');
  cloneHeader.setAttribute('inert', '');
  header.after(cloneHeader);

  updateDropdownHeights();
  syncSearchToClone();

  // Mirror hover/focus expansion from the real header's top-level items onto the clone
  const realTopItems = header.querySelectorAll('.start nav > ul > li');
  const cloneTopItems = cloneHeader.querySelectorAll('.start nav > ul > li');

  realTopItems.forEach((li, i) => {
    const cloneLi = cloneTopItems[i];
    if (!cloneLi) return;

    const open = () => cloneLi.classList.add('is-open');
    const close = () => cloneLi.classList.remove('is-open');

    li.addEventListener('mouseenter', open);
    li.addEventListener('mouseleave', close);
    li.addEventListener('focusin', open);
    li.addEventListener('focusout', close);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-newsletter"] && !Shopify.designMode) return;
  try {
    
  const popup = document.getElementById('popup-newsletter');
  if (popup) {
    const key = popup.dataset.key;
    const justSubscribed = popup.querySelector('[data-newsletter-success]');
    const hasError = popup.querySelector('.popup-newsletter__error');

    if (justSubscribed) localStorage.setItem(key, '1');

    if (justSubscribed || hasError) {
      popup.showModal();
    } else if (!localStorage.getItem(key)) {
      const delay = parseInt(popup.dataset.delay, 10) || 5;
      setTimeout(() => popup.showModal(), delay * 1000);
    }

    popup.addEventListener('close', () => localStorage.setItem(key, '1'));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('.product-accordions .accordion__trigger').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!expanded));
    });
  });

  document.querySelectorAll('.product-favorite').forEach((btn) => {
    const id = btn.dataset.productId;
    const favorites = JSON.parse(localStorage.getItem('favorites') || '[]');
    btn.setAttribute(
      'aria-pressed',
      favorites.some((f) => f.id === id),
    );

    btn.addEventListener('click', () => {
      const stored = JSON.parse(localStorage.getItem('favorites') || '[]');
      const exists = stored.findIndex((f) => f.id === id);

      if (exists > -1) {
        stored.splice(exists, 1);
        btn.setAttribute('aria-pressed', false);
        window.egToast?.success(btn.dataset.toastRemoved);
      } else {
        stored.push({
          id,
          title: btn.dataset.productTitle,
          price: btn.dataset.productPrice,
          url: btn.dataset.productUrl,
          image: btn.dataset.productImage,
        });
        btn.setAttribute('aria-pressed', true);
        window.egToast?.success(btn.dataset.toastAdded);
      }

      localStorage.setItem('favorites', JSON.stringify(stored));
      if (window.renderFavorites) window.renderFavorites();
    });
  });

  const notifyDialog = document.getElementById('notify-me-popup');
  const notifyBtn = document.querySelector('.product-bar__notify');
  const notifyForm = notifyDialog?.querySelector('[data-notify-form]');

  notifyForm?.addEventListener('submit', (e) => {
    e.preventDefault();
    const email = notifyForm.querySelector('input[type="email"]')?.value;
    const variantId = document.querySelector('[data-variant-id]')?.value;
    const productId = notifyDialog?.dataset.productId;
    if (!email || !variantId || !productId || !window.BIS) return;

    const submitBtn = notifyForm.querySelector('button[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    window.BIS.create(email, variantId, productId).then((resp) => {
      if (submitBtn) submitBtn.disabled = false;
      if (resp && resp.status === 'OK') {
        window.egToast?.success(notifyBtn?.dataset.toastNotify);
        notifyDialog.close();
        notifyForm.reset();
      } else {
        window.egToast?.error?.((resp && resp.msg) || resp?.status);
      }
    });
  });

  const optionFieldsets = document.querySelectorAll('[data-variant-option]');
  const variantsScript = document.querySelector('[data-product-variants]');
  if (optionFieldsets.length && variantsScript) {
    const variants = JSON.parse(variantsScript.textContent);
    const currency = variantsScript.dataset.currency;
    const priceEl = document.querySelector('[data-product-price]');
    const oosPriceEl = document.querySelector('[data-product-oos-price]');
    const variantIdInput = document.querySelector('[data-variant-id]');
    const productBar = document.querySelector('.product-bar');
    const moneyFormat = (cents) => {
      const amount = cents / 100;
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency,
      }).format(amount);
    };

    const getSelectedOptions = (overrideIndex, overrideValue) => {
      const selected = {};
      optionFieldsets.forEach((fs) => {
        const index = parseInt(fs.dataset.optionPosition, 10) - 1;
        const checked = fs.querySelector('input[type="radio"]:checked');
        if (checked) selected[index] = checked.value;
      });
      // The bar and in-page copies share an option position; the just-changed one wins.
      if (overrideIndex != null) selected[overrideIndex] = overrideValue;
      return selected;
    };

    const matchVariant = (selected, priorityIndex) => {
      const matches = (v) => Object.entries(selected).every(([i, val]) => v.options[i] === val);

      const full = variants.find((v) => matches(v) && v.available) || variants.find(matches);
      if (full) return full;

      const priorityValue = selected[priorityIndex];
      const partial = (v) => v.options[priorityIndex] === priorityValue;
      return variants.find((v) => partial(v) && v.available) || variants.find(partial);
    };

    const syncSelection = (variant) => {
      optionFieldsets.forEach((fs) => {
        const index = parseInt(fs.dataset.optionPosition, 10) - 1;
        const value = variant.options[index];
        const target = fs.querySelector(`input[type="radio"][value="${CSS.escape(value)}"]`);
        if (target && !target.checked) target.checked = true;
        // Only the swatches fieldset has a sibling name output; scope to it so size/texture
        // don't clobber the color name (both sets resolve their own .product-swatches-wrap).
        if (fs.classList.contains('product-swatches')) {
          const nameEl = fs.parentElement.querySelector('.product-swatches__name');
          if (nameEl) nameEl.textContent = value;
        }
      });
    };

    const galleryScroller = document.querySelector('.product-layout .product-gallery__scroller');
    const getImageName = (src) => src ? src.split('?')[0].split('/').pop().split('.').slice(0, -1).join('.') : '';

    // Scroll the slider so the matched image sits centered in the viewport.
    const centerVariantImage = (variant) => {
      if (!galleryScroller) return;
      const name = variant.featured_image ? getImageName(variant.featured_image.src) : null;
      const match = name ? galleryScroller.querySelector(`[data-image-name="${CSS.escape(name)}"]`) : null;
      if (!match) return;
      galleryScroller.scrollTo({
        left: match.offsetLeft + match.offsetWidth / 2 - galleryScroller.clientWidth / 2,
        behavior: 'smooth',
      });
    };

    const applyMatch = (match, updateUrl) => {
      if (!match) return;
      syncSelection(match);
      if (updateUrl) centerVariantImage(match);
      if (variantIdInput) variantIdInput.value = match.id;
      if (priceEl) priceEl.textContent = moneyFormat(match.price);
      if (oosPriceEl) oosPriceEl.textContent = moneyFormat(match.price);
      if (productBar) productBar.dataset.available = match.available ? 'true' : 'false';
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }
    };

    optionFieldsets.forEach((fs) => {
      // Selecting a swatch focuses its visually-hidden radio; with html { scroll-behavior: smooth }
      // + scroll-padding the browser scrolls the page to bring it into view. Snapshot the position
      // before focus moves and restore it on focus, so changing variant only ever scrolls the
      // gallery (via centerVariantImage), never the window.
      let scrollYBefore = null;
      const captureScroll = () => { scrollYBefore = window.scrollY; };
      // pointerdown covers clicks; keydown covers arrow-key navigation between radios —
      // both fire before focus moves, so we snapshot the position pre-scroll either way.
      fs.addEventListener('pointerdown', captureScroll);
      fs.addEventListener('keydown', captureScroll);
      fs.addEventListener('focusin', () => {
        if (scrollYBefore == null) return;
        const y = scrollYBefore;
        scrollYBefore = null;
        window.scrollTo({ top: y, behavior: 'auto' });
        // Some browsers run focus' scroll-into-view after focusin; re-assert next frame.
        requestAnimationFrame(() => window.scrollTo({ top: y, behavior: 'auto' }));
      });

      const handler = (e) => {
        if (e.target.type !== 'radio') return;
        const changedIndex = parseInt(fs.dataset.optionPosition, 10) - 1;
        applyMatch(matchVariant(getSelectedOptions(changedIndex, e.target.value), changedIndex), true);
      };
      fs.addEventListener('change', handler);
      fs.addEventListener('click', handler);
    });

    const initialMatch = matchVariant(getSelectedOptions());
    applyMatch(initialMatch, false);

    // Arriving from a swatch click in a collection card (?variant=…): center that
    // variant's image once layout/images have settled, mirroring an in-page swatch click.
    if (initialMatch && new URL(window.location.href).searchParams.has('variant')) {
      const centerInitial = () => centerVariantImage(initialMatch);
      if (document.readyState === 'complete') {
        requestAnimationFrame(centerInitial);
      } else {
        window.addEventListener('load', centerInitial, { once: true });
      }
    }
  }

  const atcForm = document.querySelector('.product-bar__atc')?.closest('form');
  if (atcForm) {
    atcForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      await fetch('/cart/add.js', { method: 'POST', body: new FormData(atcForm) });
      await refreshCart();
      actions.openCart();
      window.egToast?.success(atcForm.querySelector('.product-bar__atc').dataset.toastAdded);
    });
  }

  const howToWearTrigger = document.querySelector('.accordion__trigger[aria-controls="acc-how-to-wear"]');
  if (howToWearTrigger) {
    const video = document.getElementById('acc-how-to-wear')?.querySelector('video');
    if (video) {
      howToWearTrigger.addEventListener('click', () => {
        howToWearTrigger.getAttribute('aria-expanded') === 'true' ? video.play() : video.pause();
      });
    }
  }

  /* How-to-wear dialog (disabled — testing as tab instead)
  const howToWearDialog = document.getElementById('how-to-wear-dialog');
  if (howToWearDialog) {
    const video = howToWearDialog.querySelector('video');
    if (video) {
      document.querySelector('[data-target="how-to-wear-dialog"]').addEventListener('click', () => video.play());
      howToWearDialog.addEventListener('close', () => video.pause());
    }
  }
  */

  } catch(e) { console.error(e); }
})();
})();
